import React,{useEffect,useContext,useState} from 'react'
import RestaurantPOS from './ResturentPos';
import { API } from 'aws-amplify';
import { Context } from '../../../../Context';
import Error from '../../../Error';
const CounterOrder= () => {
    const [itemsData, setItemsData] = useState([]);
    const{institutionData,userData}=useContext(Context);
    useEffect(() => {
      const fetchItems = async () => {
        const items = await API.get(
          'main',
          `/any/list-items/${institutionData.institution}`,
          {}
        );
        const availableItems = items.filter(item => item.outOfStock !== true);
    
    setItemsData(availableItems);
      };
      fetchItems();
    }, []);
    if (userData?.userType !== 'admin') {
      return <Error message="Access Denied: Admins Only" />;
    }
    return <RestaurantPOS itemsData={itemsData} institutionData={institutionData} userData={userData} />;
  };
  export default CounterOrder;